import React from "react";
import { useLang } from "@/i18n";
import { RotateCcw } from "lucide-react";

const content = {
  it: {
    intro: "È possibile restituire, interamente o parzialmente, un ordine entro 14 (quattordici) giorni dalla data di ricezione.",
    sections: [
      { h: "Diritto di recesso", p: "Per esercitare il diritto di recesso, i prodotti devono essere in perfetto stato di rivendita: inutilizzati, non danneggiati, non rovinati o sporchi, muniti di tutti gli eventuali accessori e imballati nella loro confezione originale, comprensiva di istruzioni e documentazione." },
      { h: "Rimborso", p: "Mimi Silver rimborserà il prezzo del prodotto entro 14 giorni dalla data di ricevimento del prodotto reso, utilizzando lo stesso metodo di pagamento dell'ordine." },
      { h: "Spese di spedizione", p: "Le spese di spedizione del reso sono interamente a carico dell'acquirente." },
      { h: "Esclusioni", p: "I gioielli personalizzati della linea Signature, i Kit Regalo e le Gift Card non sono soggetti a reso." },
      { h: "Come procedere", p: "Per avviare un reso, contattaci all'indirizzo hello@maison-lumiere.com indicando il numero d'ordine. Ti invieremo le istruzioni per la restituzione." },
    ],
  },
  de: {
    intro: "Sie können eine Bestellung innerhalb von 14 (vierzehn) Tagen ab Erhalt ganz oder teilweise zurückgeben.",
    sections: [
      { h: "Widerrufsrecht", p: "Um das Widerrufsrecht auszuüben, müssen die Produkte in einwandfreiem, wiederverkaufsfähigem Zustand sein: unbenutzt, unbeschädigt, nicht verschmutzt, mit allen Zubehörteilen und in der Originalverpackung inklusive Anleitung und Dokumentation." },
      { h: "Rückerstattung", p: "Mimi Silver erstattet den Produktpreis innerhalb von 14 Tagen nach Erhalt der zurückgesandten Ware über dieselbe Zahlungsmethode der Bestellung." },
      { h: "Versandkosten", p: "Die Rücksendekosten gehen vollständig zu Lasten des Käufers." },
      { h: "Ausschlüsse", p: "Personalisierter Schmuck der Signature-Linie, Geschenksets und Geschenkgutscheine sind vom Umtausch ausgeschlossen." },
      { h: "Vorgehen", p: "Um eine Rücksendung zu starten, kontaktieren Sie uns unter hello@maison-lumiere.com mit Ihrer Bestellnummer. Wir senden Ihnen die Rücksendeanweisungen." },
    ],
  },
  fr: {
    intro: "Vous pouvez retourner, totalement ou partiellement, une commande dans les 14 (quatorze) jours suivant la réception.",
    sections: [
      { h: "Droit de rétractation", p: "Pour exercer le droit de rétractation, les produits doivent être en parfait état de revente : non utilisés, non endommagés, non abîmés ni salis, munis de tous les accessoires et emballés dans leur emballage d'origine, avec notice et documentation." },
      { h: "Remboursement", p: "Mimi Silver remboursera le prix du produit dans les 14 jours suivant la réception du produit retourné, via le même moyen de paiement que la commande." },
      { h: "Frais d'expédition", p: "Les frais de retour sont entièrement à la charge de l'acheteur." },
      { h: "Exclusions", p: "Les bijoux personnalisés de la ligne Signature, les coffrets cadeaux et les cartes cadeaux ne sont pas soumis au retour." },
      { h: "Comment procéder", p: "Pour initier un retour, contactez-nous à hello@maison-lumiere.com en indiquant votre numéro de commande. Nous vous enverrons les instructions de retour." },
    ],
  },
  en: {
    intro: "You may return an order, in whole or in part, within 14 (fourteen) days of receipt.",
    sections: [
      { h: "Right of withdrawal", p: "To exercise the right of withdrawal, products must be in perfect resalable condition: unused, undamaged, not soiled, with all accessories and packed in their original packaging, including instructions and documentation." },
      { h: "Refund", p: "Mimi Silver will refund the product price within 14 days of receiving the returned item, using the same payment method as the order." },
      { h: "Shipping costs", p: "Return shipping costs are entirely borne by the buyer." },
      { h: "Exclusions", p: "Personalised jewelry from the Signature line, Gift Sets and Gift Cards are not eligible for return." },
      { h: "How to proceed", p: "To start a return, contact us at hello@maison-lumiere.com with your order number. We will send you the return instructions." },
    ],
  },
};

export default function Returns() {
  const { t, lang } = useLang();
  const c = content[lang] || content.en;

  return (
    <div className="px-4 sm:px-8 lg:px-16 py-16 lg:py-24 fade-up min-h-[60vh]">
      <div className="max-w-2xl mx-auto">
        <RotateCcw className="w-8 h-8 text-[#C5A880] mb-5" strokeWidth={1.2} />
        <h1 data-testid="returns-title" className="font-serif-display text-4xl sm:text-5xl text-[#1A1F2C] leading-none mb-6">{t("returns_title")}</h1>
        <p className="text-base text-[#6B7280] leading-relaxed mb-12">{c.intro}</p>
        <div className="space-y-10">
          {c.sections.map((s, i) => (
            <div key={i} className="border-t border-[#EAE6E1] pt-6">
              <h2 className="text-xs tracking-luxe uppercase text-[#C5A880] mb-3">{s.h}</h2>
              <p className="text-base text-[#1A1F2C] leading-relaxed">{s.p}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
